export default {
    meta: {
        title: '拓店宝-拓店任务表单页',
        url: '/task',
        urlName: '拓店任务' // 埋点字段，上报归属的模块
    }
};
